// internationalization
import type { TFunction } from 'i18next';

// shared components
import type { DanishAddressFieldValue } from '@/components/ui/form';

// libraries
import { z } from 'zod';

export function createGatewayFormSchema(t: TFunction) {
  return z.object({
    name: z.string().min(1, t('input.required', { ns: 'validation' })),
    rfuId: z
      .string()
      .min(1, t('input.required', { ns: 'validation' }))
      .refine((value) => Number.isFinite(Number(value)) && Number(value) > 0, {
        message: t('input.invalidNumber', { ns: 'validation' }),
      }),
    description: z.string(),
    address: z
      .custom<DanishAddressFieldValue>()
      .refine(
        (value) =>
          Boolean(value?.displayName?.trim()) &&
          Number.isFinite(value?.latitude) &&
          Number.isFinite(value?.longitude),
        { message: t('input.required', { ns: 'validation' }) },
      ),
  });
}

export type CreateGatewayFormValues = z.infer<
  ReturnType<typeof createGatewayFormSchema>
>;
